module.exports = __webpack_public_path__ + "static-v-shop/1786468182979/img/logo_visadebito.ed193bb5.png";